export default __webpack_public_path__ + "static/media/room1-MASK-wood-rot30.82de80e8.png";